// Import any necessary dependencies here

/**
 * Retrieves the auto-fill dropdown items for a given checkpoint based on its response type and status.
 *
 * @param {PatrolCheckpoint} checkpoint - The checkpoint object containing details about the response type and statuses.
 * @returns {string[]} An array of names of the auto-fill dropdown items.
 */
export function getAutoFillDropdownItems(
	checkpoint: PatrolCheckpoint,
): string[] {
	let autoFillDropdownItems: string[] = [];

	// Retrieve the selected status based on the SelectedStatusID
	const selectedStatus: CheckpointStatus | undefined =
		checkpoint?.Status.find(
			(status) => status.StatusID === checkpoint.SelectedStatusID,
		);

	// Check if the response type is 'Comment' and filter dropdown items accordingly
	if (checkpoint?.ResponseTypeName === 'Comment') {
		autoFillDropdownItems =
			checkpoint?.Dropdowns.filter(
				(dropdown) => dropdown.DropdownType === 'noStatusAutoFill',
			).map((item) => item.Name) || [];
	}
	// Check if the response type is 'Status' and filter dropdown items based on status number
	else if (checkpoint?.ResponseTypeName === 'Status') {
		switch (selectedStatus?.StatusNumber) {
			case 1:
				autoFillDropdownItems =
					checkpoint?.Dropdowns.filter(
						(dropdown) =>
							dropdown.DropdownType === 'clearStatusAutoFill',
					).map((item) => item.Name) || [];
				break;
			case 2:
				autoFillDropdownItems =
					checkpoint?.Dropdowns.filter(
						(dropdown) =>
							dropdown.DropdownType === 'warningStatusAutoFill',
					).map((item) => item.Name) || [];
				break;
			case 3:
				autoFillDropdownItems =
					checkpoint?.Dropdowns.filter(
						(dropdown) =>
							dropdown.DropdownType === 'emergencyStatusAutoFill',
					).map((item) => item.Name) || [];
				break;
			default:
				autoFillDropdownItems = [];
		}
	}

	return autoFillDropdownItems;
}
